// extracted by mini-css-extract-plugin
module.exports = {"tableWrapper":"styles_tableWrapper__1jcua","col":"styles_col__2V4je","fulfillmentStatus":"styles_fulfillmentStatus__1dokA","emailCol":"styles_emailCol__2QkkI"};